export default function Logo() {
  return (
    <div className='flex items-center justify-center max-w-[80%] mx-auto'>
      <img src='/full-logo.svg' alt='logo' className='object-cover' />
    </div>
  );
}
